import { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { X, Share, Plus, Home } from 'lucide-react';

const IOSInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Detect iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Detect if already installed (standalone mode)
    const isStandalone = window.navigator.standalone === true || 
                         window.matchMedia('(display-mode: standalone)').matches;
    
    // Check if user dismissed the prompt
    const dismissed = localStorage.getItem('ios-install-prompt-dismissed');
    
    // Show prompt only on iOS, not installed, and not dismissed
    if (isIOS && !isStandalone && !dismissed) {
      // Delay showing prompt to not overwhelm user
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('ios-install-prompt-dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-in slide-in-from-bottom">
      <Card className="shadow-2xl" style={{ backgroundColor: '#224049', border: '2px solid #D4AD6A' }}>
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <Home className="w-5 h-5" style={{ color: '#D4AD6A' }} />
                <h3 className="font-bold" style={{ color: '#D4AD6A' }}>Instala UID en tu iPhone</h3>
              </div>
              
              <p className="text-sm mb-3" style={{ color: '#EAE0D5' }}>
                Para usar UID como una app en tu iPhone:
              </p>

              {/* Visual Instructions */}
              <div className="space-y-2 mb-3">
                <div className="flex items-center gap-2 p-2 rounded" style={{ backgroundColor: 'rgba(232, 202, 148, 0.1)' }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: '#D4AD6A', color: '#224049' }}>
                    1
                  </div>
                  <div className="flex items-center gap-2">
                    <Share className="w-4 h-4" style={{ color: '#D4AD6A' }} />
                    <p className="text-xs" style={{ color: '#EAE0D5' }}>
                      Toca el botón <strong>Compartir</strong> abajo ↓
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 rounded" style={{ backgroundColor: 'rgba(232, 202, 148, 0.1)' }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: '#D4AD6A', color: '#224049' }}>
                    2
                  </div>
                  <div className="flex items-center gap-2">
                    <Plus className="w-4 h-4" style={{ color: '#D4AD6A' }} />
                    <p className="text-xs" style={{ color: '#EAE0D5' }}>
                      Selecciona <strong>"Agregar a pantalla de inicio"</strong>
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 rounded" style={{ backgroundColor: 'rgba(232, 202, 148, 0.1)' }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: '#D4AD6A', color: '#224049' }}>
                    3
                  </div>
                  <p className="text-xs" style={{ color: '#EAE0D5' }}>
                    Confirma tocando <strong>"Agregar"</strong>
                  </p>
                </div>
              </div>

              <Button
                onClick={handleDismiss}
                size="sm"
                className="w-full"
                variant="outline"
                style={{ borderColor: '#D4AD6A', color: '#D4AD6A', backgroundColor: 'transparent' }}
                data-testid="dismiss-ios-install-button"
              >
                Entendido
              </Button>
            </div>
            <button
              onClick={handleDismiss}
              className="p-1 rounded-full hover:bg-opacity-20 hover:bg-white"
              style={{ color: '#D4AD6A' }}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default IOSInstallPrompt;
